import React from 'react';


const HighestRankIcon = ({className = 'absolute -bottom-2.5 z-20'}) => {
    // let showImage = TB.platformHasImage(
    //     'Asset_Metric_Top_Rank_Icon'
    // );

    // if (showImage) {
    //     return (
    //         <div className="highest-rank" style={{
    //             backgroundImage: `url("${laravel.platform_settings.Asset_Metric_Top_Rank_Icon}")`
    //         }}/>
    //     );
    // }

    // TODO: change this to save to platform like above
    return <img className={className} src="/images/badge-icon.png" />

    return (
        <i className="fas fa-award highest-rank" style={{
            color: 'var(--theme-warning)',
            backgroundImage: 'none',
            fontSize: '40px',
        }}/>
    );
};

export default HighestRankIcon